export default __webpack_public_path__ + "media/zurb/img/ecommerce/shopping_flow6-f21ee58f88d62ca94888bb8eb0f33869.png";